<p class="m-0"><strong>Id: </strong>{{ infoData.id }}</p>
<p class="m-0"><strong>Izveidotājs: </strong>{{ infoData.firstSavedByUserFullName }} ({{ infoData.firstSaveTime | date : DATE_TIME_FORMAT }})</p>
<p class="m-0"><strong>Pēdējais labotājs: </strong>{{ infoData.savedByUserFullName }} ({{ infoData.saveTime | date : DATE_TIME_FORMAT }})</p>
<p class="m-0">
  <strong>Dzēsts: </strong>
  @if (infoData.isDeleted) {
    <i nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></i>
  }
  @if (!infoData.isDeleted) {
    <i nz-icon nzType="close-circle" nzTheme="twotone" nzTwotoneColor="#c41a1a"></i>
  }
</p>
<div *nzModalFooter></div>
